export default __webpack_public_path__ + "static/media/my-list-ribbon-add.3a59e299.svg";